import { Box, Typography, TypographyProps } from "@mui/material"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function DisplayNotFoundInfo({
    label,
    variant = "body1",
    justifyContent = "center",
}: DisplayNotFoundInfoProps) {
    return (
        <Box {...{justifyContent}} display="flex" alignItems="center" py={4} gap={1}>
            <InfoOutlinedIcon sx={{ color: "gray" }} />
            <Typography {...{ variant }} color="gray">{label}</Typography>
        </Box>
    )
}

interface DisplayNotFoundInfoProps {
    label: string,
    variant?: TypographyProps['variant']
    justifyContent?: "flex-start" | "center" | "flex-end"
}